import React from "react";
import AudioContainer from "./AudioContainer";
import { EditorContext } from "views/components/Editor/EditorContext";

const AudioInEditorContext = props => (
  <EditorContext.Consumer>
    {({
      isPlaying = {},
      isPaused = {},
      currentPlayingTime = {},
      designData,
      currentPageId
    }) => {
      // Get page data for timeline duration
      const pageData =
        designData?.pages?.[props.pageId] || designData?.pages?.[currentPageId];
      return (
        <AudioContainer
          {...props}
          isPlaying={isPlaying[props.pageId]}
          isPaused={isPaused[props.pageId]}
          currentPlayingTime={currentPlayingTime[props.pageId]}
          pageData={pageData}
          currentPageId={currentPageId}
        />
      );
    }}
  </EditorContext.Consumer>
);

export default AudioInEditorContext;
